import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { LocalStorageService } from 'src/app/shared/services/angular-service/local-storage.service';
import { LoginSignupService } from 'src/app/shared/services/node-api/login-signup.service';
import { TansactionService } from 'src/app/shared/services/node-api/tansaction.service';

@Component({
  selector: 'app-purchase-subscription-suggestion-layout',
  templateUrl: './purchase-subscription-suggestion-layout.component.html',
  styleUrls: ['./purchase-subscription-suggestion-layout.component.scss'],
})
export class PurchaseSubscriptionSuggestionLayoutComponent implements OnInit , OnDestroy{
  @Input() planInCart;

  plan: string;
  packages: any;
  emailId: String;
  advanceButton = false;
  premiumButton = false;
  private subscription = new Subscription();
  onSession: string;
  role: string;

  constructor(
    private loginSignupService: LoginSignupService,
    private transactionService: TansactionService,
    private localStorageService : LocalStorageService
  ) {}

  ngOnInit(): void {
    this.onSession = this.localStorageService.getItem('onSession')
    this.emailId = this.loginSignupService.getUserSession()?.user?.email;
    this.plan = this.localStorageService.getItem('plan');
    this.role = this.localStorageService.getItem('role');
  
    this.currentPrice();
    this.subscribePlan();
  }

  subscribePlan() {
    this.subscription.add(
    this.transactionService.planInCartSubject$.subscribe((data: any) => {
      this.planInCart = data.plan;
    }));
  }

  currentPrice() {
    this.transactionService
      .currentPrice()
      .then((data: any) => {
        this.packages = data;
      })
      .catch((err: any) => {});
  }

  cartPlan(category) {
    let currentOption;
    let startDate = new Date();
    currentOption = {
      email: this.emailId,
      startdate: startDate,
      enddate: startDate.setDate(startDate.getDate() + 30),
      category: category,
      status: 'open',
    };
    this.transactionService.createCartPayOut(currentOption).then(
      (data: any) => {
        window.location.reload();
      },
      (err) => {
        console.log(err);
      }
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

}
